import { useState } from "react";
import { Product } from "../../types/Product";


export function useProductDetail(product: Product, productImages: string[]) {
  //const [quantity, setQuantity] = useState(minimumPurchase);
  const [selectedImage, setSelectedImage] = useState(0);
  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  const [fullscreenDialogOpen, setFullscreenDialogOpen] = useState(false);

  //const handleQuantityChange = (newQuantity: number) => {
  //  const minQuantity = minimumPurchase;
  //  const maxQuantity = product.stock || 0;
    
  //  if (newQuantity >= minQuantity && newQuantity <= maxQuantity) {
  //    setQuantity(newQuantity);
  //  }
  //};

  const handleCalculateShipping = (zipCode: string) => {
    console.log("Calculate shipping for:", zipCode);
  };

  const nextImage = () => {
    setSelectedImage((prev) => (prev + 1) % productImages.length);
  };

  const prevImage = () => {
    setSelectedImage((prev) => (prev - 1 + productImages.length) % productImages.length);
  };

  const openPaymentDialog = () => {
    setPaymentDialogOpen(true);
  };

  const closePaymentDialog = () => {
    setPaymentDialogOpen(false);
  };

  const openFullscreenDialog = () => {
    setFullscreenDialogOpen(true);
  };

  const closeFullscreenDialog = () => {
    setFullscreenDialogOpen(false);
  };

  const formatPrice = (price?: number) => {
    if (!price) return "$0";
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 0,
    }).format(price);
  };

  const getStockText = (stock?: number | null) => {
    if (stock === null || stock === undefined) return "Disponible";
    if (stock === 0) return "Sin stock";
    if (stock === 1) return "Última unidad";
    if (stock <= 5) return `Solo ${stock} unidades`;
    return `${stock} unidades disponibles`;
  };

  const isProductAvailable = () => {
    return (product.stock === null || (product.stock ?? 0) > 0) && product.publicado;
  };

  const getPromotionText = () => {
    if (product.precio) {
      return "10% OFF COMPRANDO 1 O MÁS";
    }
    return undefined;
  };

  return {
    // State
    //quantity,
    selectedImage,
    paymentDialogOpen,
    fullscreenDialogOpen,
    productImages,
    
    // Computed values
    formattedPrice: formatPrice(product.precio),
    stockText: getStockText(product.stock),
    isAvailable: isProductAvailable(),
    promotionText: getPromotionText(),
    
    // Actions
    //handleQuantityChange,
    handleCalculateShipping,
    nextImage,
    prevImage,
    setSelectedImage,
    openPaymentDialog,
    closePaymentDialog,
    openFullscreenDialog,
    closeFullscreenDialog,
    
    // Helper functions
    formatPrice,
    getStockText,
    isProductAvailable,
    getPromotionText,
  };
}














